import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../../container/authContext';
import { usePermission } from '../../../container/permissionContext';
import { ReactComponent as CorporateLibraryIcon } from '../../../assets/images/corporate-library.svg';
import { ReactComponent as CNAAssignmentsIcon } from '../../../assets/images/cna-assignments.svg';
import { ReactComponent as BedboardIcon } from '../../../assets/images/bedboard.svg';
import { STATIC_ROUTES } from '../../../constants/routes';
import './styles.scss';
import { isTablet, isMobile } from 'react-device-detect';

const SideBarMenu = () => {
  const { user } = useAuth();
  const { isSuperAdmin, hasPermissionByCodeName } = usePermission();

  return (
    <div className="tablet-sidebar">
      <ul className="tablet-sidebar-menu">
        {!isSuperAdmin() && !user.is_unit_user && (
          <li className={`tablet-sidebar-menu-item ${location.pathname.includes('corporate-library') ? 'active' : ''}`}>
            <Link to={STATIC_ROUTES.CORPORATE_LIBRARY} className="tablet-sidebar-menu-link">
              <CorporateLibraryIcon />
              <span>Corporate Library</span>
            </Link>
          </li>
        )}

        {(user.has_cna_permission || user.is_unit_user) && user.company && isTablet && (
          <li className={`tablet-sidebar-menu-item ${location.pathname.includes('/cna') ? 'active' : ''}`}>
            <Link to={STATIC_ROUTES.CNA_ASSIGNMENTS} className="tablet-sidebar-menu-link">
              <CNAAssignmentsIcon />
              <span>CNA Assignments</span>
            </Link>
          </li>
        )}
        {isMobile && !isTablet && user.has_access_to_mobile_cna && (
          <li className={`tablet-sidebar-menu-item ${location.pathname.includes('/cna') ? 'active' : ''}`}>
            <Link to={STATIC_ROUTES.CNA_ASSIGNMENTS_MOBILE} className="tablet-sidebar-menu-link">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8M9 2H15C15.5523 2 16 2.44772 16 3V5C16 5.55229 15.5523 6 15 6H9C8.44772 6 8 5.55229 8 5V3C8 2.44772 8.44772 2 9 2Z"
                  stroke="#7F56D9"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <span>CNA Assignments</span>
            </Link>
          </li>
        )}
        {(user.has_bedboard_permission || hasPermissionByCodeName('contacts_management')) && user.company && (
          <li className={`tablet-sidebar-menu-item ${location.pathname.includes('/bedboard') ? 'active' : ''}`}>
            <Link to={STATIC_ROUTES.BEDBOARD} className="tablet-sidebar-menu-link">
              <BedboardIcon />
              <span>Bed occupancy</span>
            </Link>
          </li>
        )}
        {!isTablet &&
          user.company &&
          (hasPermissionByCodeName('scheduling_management') ||
            hasPermissionByCodeName('scheduling_viewing') ||
            hasPermissionByCodeName('shift_pickup_for_nurses') ||
            hasPermissionByCodeName('shift_pickup_for_cnas') ||
            (user.has_shift_assignments && isMobile)) && (
            <li
              className={`tablet-sidebar-menu-item ${location.pathname.includes('/scheduling') || location.pathname.includes('/pickup-shift') ? 'active' : ''}`}
            >
              <Link
                to={
                  hasPermissionByCodeName('scheduling_management') || hasPermissionByCodeName('scheduling_viewing')
                    ? STATIC_ROUTES.SCHEDULING
                    : STATIC_ROUTES.PICKUP_SHIFT
                }
                className="tablet-sidebar-menu-link"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M16 2V6M8 2V6M3 10H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>Scheduling</span>
              </Link>
            </li>
          )}

        {user && user.company && hasPermissionByCodeName('employee_phones_view') && (
          <li className="tablet-sidebar-menu-item">
            <Link
              to={STATIC_ROUTES.PHONES_MODULE.replace(':companyId', user.company.id)}
              className={`tablet-sidebar-menu-link ${location.pathname.includes('/phones') ? 'active' : ''}`}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_15107_12050)">
                  <path
                    d="M21.0881 17.3185V20.3185C21.0893 20.597 21.0322 20.8727 20.9206 21.1279C20.8091 21.3831 20.6454 21.6121 20.4402 21.8004C20.235 21.9887 19.9927 22.132 19.7289 22.2212C19.4651 22.3105 19.1855 22.3436 18.9081 22.3185C15.831 21.9842 12.8751 20.9327 10.2781 19.2485C7.86196 17.7132 5.81347 15.6647 4.27813 13.2485C2.58811 10.6397 1.53637 7.66953 1.20813 4.57853C1.18314 4.302 1.216 4.02329 1.30463 3.76016C1.39325 3.49702 1.5357 3.25522 1.72289 3.05016C1.91009 2.84509 2.13793 2.68124 2.39192 2.56906C2.64591 2.45687 2.92047 2.3988 3.19813 2.39853H6.19813C6.68344 2.39376 7.15392 2.56561 7.52189 2.88207C7.88986 3.19852 8.13021 3.63798 8.19813 4.11853C8.32475 5.0786 8.55958 6.02126 8.89813 6.92853C9.03267 7.28646 9.06179 7.67545 8.98204 8.04941C8.90228 8.42338 8.71699 8.76665 8.44813 9.03853L7.17813 10.3085C8.60168 12.8121 10.6746 14.885 13.1781 16.3085L14.4481 15.0385C14.72 14.7697 15.0633 14.5844 15.4372 14.5046C15.8112 14.4249 16.2002 14.454 16.5581 14.5885C17.4654 14.9271 18.4081 15.1619 19.3681 15.2885C19.8539 15.3571 20.2975 15.6017 20.6147 15.976C20.9318 16.3503 21.1003 16.8281 21.0881 17.3185Z"
                    stroke="#98A2B3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M18.0223 7.66671C19.8632 7.66671 21.3556 6.17432 21.3556 4.33335C21.3556 2.49239 19.8632 1 18.0223 1C16.1813 1 14.6889 2.49239 14.6889 4.33335C14.6889 6.17432 16.1813 7.66671 18.0223 7.66671Z"
                    stroke="#98A2B3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.7179 10.9974C13.9645 10.0433 14.5211 9.19821 15.3002 8.59486C16.0793 7.99151 17.0367 7.6641 18.0221 7.66406C19.0076 7.66403 19.9651 7.99138 20.7442 8.59467C21.5233 9.19796 22.08 10.043 22.3267 10.9971"
                    stroke="#98A2B3"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_15107_12050">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              <span>Phone book</span>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default SideBarMenu;
